import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { SiteRenderer } from "../components/sites/SiteRenderer";

export default function PublicSite() {
  const { slug, page } = useParams();
  const nav = useNavigate();
  const [site, setSite] = useState(undefined);
  useEffect(() => { api.get(`/public/sites/${slug}`).then((r) => setSite(r.data)).catch(() => setSite(null)); }, [slug]);
  const cur = site ? (site.pages.find((p) => p.slug === page) || site.pages[0]) : null;
  useEffect(() => {
    if (!site || !cur) return;
    document.title = cur.seo_title || `${cur.title} | ${site.name}`;
    let m = document.querySelector('meta[name="description"]');
    if (!m) { m = document.createElement("meta"); m.name = "description"; document.head.appendChild(m); }
    m.content = cur.seo_desc || "";
    window.scrollTo(0, 0);
  }, [site, cur]);
  if (site === undefined) return <div className="grid min-h-screen place-items-center bg-white text-sm text-slate-500">Loading…</div>;
  if (!site) return <div className="grid min-h-screen place-items-center bg-white text-slate-600" data-testid="site-not-found">This website isn't available.</div>;
  return <div className="min-h-screen" data-testid="public-site"><SiteRenderer site={site} pageSlug={cur.slug} linkBase={`/site/${slug}`} onNavigate={(s) => nav(s === site.pages[0].slug ? `/site/${slug}` : `/site/${slug}/${s}`)} /></div>;
}
